import { Segmented } from "antd";
import { USER_GROUP_OPTIONS, isGrouped } from "./grouping";

const GroupByControl = ({ value, onChange, options = USER_GROUP_OPTIONS, groupCount = 0, allCollapsed, onExpandAll, onCollapseAll }) => (
  <div
    className="d-flex align-items-center justify-content-between flex-wrap"
    style={{ gap: "8px 16px", marginBottom: "12px" }}
  >
    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
      <span id="doc-group-by-label" style={{ fontSize: "13px", fontWeight: 600, color: "#374151" }}>
        Group by
      </span>
      <Segmented
        aria-labelledby="doc-group-by-label"
        options={options}
        value={value || ""}
        onChange={onChange}
      />
    </div>
    {isGrouped(value) && groupCount > 0 && (
      <div style={{ fontSize: "12px", color: "#6b7280" }}>
        {groupCount} {groupCount === 1 ? "group" : "groups"} on this page ·{" "}
        <button
          type="button"
          className="btn btn-link p-0"
          style={{ fontSize: "12px", fontWeight: 600, color: "rgb(211, 0, 26)", verticalAlign: "baseline" }}
          onClick={allCollapsed ? onExpandAll : onCollapseAll}
        >
          {allCollapsed ? "Expand all" : "Collapse all"}
        </button>
      </div>
    )}
  </div>
);

export default GroupByControl;
